export default function PHP_str_rot13() {
  return (
    <div>
      <h1>PHP_str_rot13</h1>
    </div>
  );
}
